'use client';

import React, { useState } from 'react';
import { Dialog, DialogContent, DialogTrigger, DialogTitle } from '@/components/ui/dialog';
import { TerminalDocument } from './terminal/TerminalDocument';
import { TERMS_OF_SERVICE_CONTENT } from '@/lib/legal/terms-of-service';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';

interface TermsOfServiceModalProps {
  children: React.ReactNode;
  className?: string;
  // Allow external control for direct linking
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

export function TermsOfServiceModal({
  children,
  className = '',
  open: externalOpen,
  onOpenChange: externalOnOpenChange
}: TermsOfServiceModalProps) {
  const [internalOpen, setInternalOpen] = useState(false);

  // Use external state if provided, otherwise internal state
  const isOpen = externalOpen !== undefined ? externalOpen : internalOpen;
  const setIsOpen = externalOnOpenChange || setInternalOpen;

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild className={className}>
        {children}
      </DialogTrigger>
      <DialogContent 
        className="max-w-5xl max-h-[90vh] p-0 bg-transparent border-none shadow-none overflow-hidden"
        hideOverlay={true}
      >
        <VisuallyHidden>
          <DialogTitle>Terms of Service</DialogTitle>
        </VisuallyHidden>
        <TerminalDocument
          title="Terms of Service v2025.1.0"
          content={TERMS_OF_SERVICE_CONTENT}
          onClose={() => setIsOpen(false)}
          showLineNumbers={true}
        />
      </DialogContent>
    </Dialog>
  );
}

export default TermsOfServiceModal;